<template><div class="main">
  <template v-if="!newRecord">
    <sticky-bar
        search="search provisioning records (name / serial / imei / mac / iccid / version)"
        v-model="query"
      >Provisioning</sticky-bar>
    <div class="flex-fill padded">
      <Loading v-if="loadingRef !== null" />
      <div v-else class="card-box">
        <button @click="editNewRecord()">Add New Record</button>
        <provisioning-card
            v-for="pr of records"
            :key="`pr-${pr.id}`"
            :pr="pr"
            :parts="parts"
            @edit="editNewRecord(pr)"
          />
      </div>
    </div>
  </template>
  <template v-else>
    <sticky-bar @back="newRecord=null">
      <template v-if="newRecord.name">Edit Provisioning Record: {{ newRecord.name }}</template>
      <template v-else>New Provisioning Record</template>
    </sticky-bar>
    <div class="flex-fill padded">
      <provisioning-form :pr="newRecord" :parts="parts" @done="refresh()" />
    </div>
  </template>
</div></template>
<script>
import api from '../api'
import Loading from './Loading'
import ProvisioningCard from './ProvisioningCard'
import ProvisioningForm from './ProvisioningForm'
import StickyBar from './StickyBar'
export default {
  name: 'provisioning',
  data() {
    return {
      query: '',
      loadingRef: null,
      statusRef: null,
      records: [],
      newRecord: null,
      parts: null,
    }
  },
  components: { Loading, ProvisioningCard, ProvisioningForm, StickyBar },
  created() {
    this.refresh()
    this.statusInterval = setInterval(() => { this.getStatus() }, 5000)
  },
  destroyed() {
    clearInterval(this.statusInterval)
    delete this.statusInterval
  },
  methods: {
    async refresh() {
      let ref

      this.newRecord = null

      if (this.loadingRef)
        this.loadingRef.cancel()

      if (this.parts === null) {
        const parts = { }
        ref = this.loadingRef = { }
        try {
          parts.list = await api.getPartsList()
        } finally {
          if (this.loadingRef === ref)
            this.loadingRef = null
        }
        parts.dict = {}
        for (const [ key, val ] of parts.list)
          parts.dict[key] = val
        this.parts = parts
      }

      ref = this.loadingRef = { query: this.query }
      this.records = []
      try {
        this.records = await api.getProvisioningRecords(this.loadingRef)
      } finally {
        if (this.loadingRef === ref)
          this.loadingRef = null
      }
      this.getStatus()
    },
    async getStatus() {
      if (this.statusRef)
        this.statusRef.cancel()
      this.statusRef = { ids: this.records.map(pr => pr.id) }
      try {
        let i = 0
        for (const stat of await api.getProvisioningRecordsConnected(this.statusRef)) {
          const pr = this.records[i]
          if (!pr || stat[0] !== pr.id) {
            console.error('Status IDs did not match visible IDs.', stat[0], pr ? pr.id : 'no pr')
            break
          }
          this.$set(pr, 'status', stat.slice(1))
          i++
        }
      } finally {
        this.statusRef = null
      }
    },
    editNewRecord(pr) {
      this.newRecord = (
        pr
          ? Object.assign({}, pr)
          : {
            firmware_version: '',
            serial_no: '',
            imei: '',
            part: '',
            mac: '',
            config_version: '',
            sim: '',
          }
      )
    },
  },
  watch: {
    query() { this.refresh() },
  },
}
</script>
<style lang="scss" scoped>
.card-box {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
